export default "__VITE_ASSET__BoMMycUH__"